var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-py-3 tw-px-5",class:_vm.alertClass},[(_vm.icon)?[_c(_vm.icon,{tag:"component",staticClass:"tw-h-4 tw-w-4 tw-flex-shrink-0"})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }